import { render, staticRenderFns } from "./jlzxDetail.vue?vue&type=template&id=10f786c6&scoped=true"
import script from "./jlzxDetail.vue?vue&type=script&lang=js"
export * from "./jlzxDetail.vue?vue&type=script&lang=js"
import style0 from "./jlzxDetail.vue?vue&type=style&index=0&id=10f786c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f786c6",
  null
  
)

export default component.exports